import React from 'react'
import Notes from './notes/Notes'

export default function NotesTab({
  canDeleteOrUpdateOldNotes, notes, notesPath, setNotes, currentAdminEmail
}) {
  return (
    <>
      <div className='card'>
        <div className='card-content'>
          <div className='card-title'>Notes</div>

          <div className='card-body'>
            <Notes
              canDeleteOrUpdateOldNotes={ canDeleteOrUpdateOldNotes }
              notes={ notes }
              notesPath={ notesPath }
              setNotes={ setNotes }
              currentAdminEmail={ currentAdminEmail }
            />
          </div>
        </div>
      </div>
    </>
  )
}